var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfoEarthsec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.331,
    height: 72.813,
    viewBox: "0 0 123.331 72.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 33.01,
    cy: 33.01,
    r: 33.01,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ufo-earthsec",
    transform: "translate(-1463.455 -379.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11101",
    "data-name": "Group 11101",
    transform: "translate(1463.455 379.306)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 33.01,
    cy: 33.01,
    r: 33.01,
    transform: "translate(26.142)",
    fill: "#dbaf6a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49858",
    "data-name": "Path 49858",
    d: "M1475.037,442.808c1.845.23,3.612-.7,5.237-1.6,22.54-12.517,45.081-25.036,67.4-37.934,5.239-3.027,10.564-6.154,14.547-10.709a27.547,27.547,0,0,0-11.675,4.109,76.172,76.172,0,0,1,36.235-14.536c-6.141,6.241-13.5,11.123-20.8,15.957-31.747,21.022-63.917,42.257-99.875,54.779-1.016.354-2.614.342-2.656-.733a1.742,1.742,0,0,1,.5-1.087,110.374,110.374,0,0,1,27.219-24.5C1485.906,432.073,1479.973,436.945,1475.037,442.808Z",
    transform: "translate(-1463.455 -380.264)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11100",
    "data-name": "Group 11100",
    transform: "translate(26.142)",
    opacity: 0.11,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11099",
    "data-name": "Group 11099",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49859",
    "data-name": "Path 49859",
    d: "M1504.58,427.082c4.486-1.158,7.817-4.838,11.847-7.125a8.874,8.874,0,0,1,5.382-1.408c1.631.209,3.1,1.123,4.721,1.4,1.7.288,3.429-.144,5.151-.132a10,10,0,0,1,9.926,10.26c1.566,1.168,2.311,3.117,2.907,4.978a12.06,12.06,0,0,1,.746,6.307c-.483,2.089-2.369,4.005-4.5,3.786-.889-.091-1.957-.473-2.555.19a1.736,1.736,0,0,0,.162,2.049,4.945,4.945,0,0,1,1.068,1.917,3.33,3.33,0,0,1-.349,1.637c-1.174,2.935-2.447,6.006-4.92,7.974a12.163,12.163,0,0,1-7.477,2.359,32.909,32.909,0,0,1-7.879-1.17,3.168,3.168,0,0,0,1.732-3.8c-.523-1.56-2.245-2.574-2.5-4.2-.229-1.476.885-2.851,2.161-3.63s2.756-1.177,4.014-1.985a7.964,7.964,0,0,0,3.5-6.688,9.545,9.545,0,0,0-3.261-6.918,7.451,7.451,0,0,0-6.666-1.937,3.028,3.028,0,0,1-1.323.2c-1.31-.247-1.293-2.194-2.219-3.153a2.744,2.744,0,0,0-3.212-.192,17.2,17.2,0,0,0-2.664,2.19c-1.1.926-2.58,2.02-2.217,3.415.3,1.172,1.714,1.593,2.894,1.868a7.584,7.584,0,0,1,3.425,1.495,2.942,2.942,0,0,1,.861,3.4c-.528,1-1.766,1.486-2.255,2.508a7.8,7.8,0,0,0-.26,2.814,4.622,4.622,0,0,1-3.984,4.112c-2.151.231-4.147-1.093-5.781-2.509a23.669,23.669,0,0,1-7.079-9.851,16.269,16.269,0,0,1-.917-5.61c.024-1.458.161-4.587,1.3-5.679,1.027-.98,3.181.778,4.442,1.1A11.634,11.634,0,0,0,1504.58,427.082Z",
    transform: "translate(-1499.626 -392.589)",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49860",
    "data-name": "Path 49860",
    d: "M1516.843,388.349a3.822,3.822,0,0,0,3.387,1.753,5.587,5.587,0,0,0,3.577-1.592c.459-.43.945-.955,1.574-.945.575.009,1.048.476,1.616.565,1.441.227,2.159-1.872,3.556-2.3.924-.281,1.925.247,2.875.075,1.544-.278,2.191-2.141,3.466-3.054a6.377,6.377,0,0,1,2.465-.885l2.482-.52a12.971,12.971,0,0,1,5.3-.362,6.487,6.487,0,0,1,2.877,1.425c-.853.5-1.895-.075-2.8-.463s-2.285-.376-2.527.58c-.251.991,1.009,1.631,2,1.868l6.087,1.453a28.512,28.512,0,0,0,8.622,1.145,8.859,8.859,0,0,0-2.83-7.085,14.879,14.879,0,0,0-4.156-2.471,50.376,50.376,0,0,0-20.542-4.184,30.2,30.2,0,0,0-10.139,1.613,16.869,16.869,0,0,0-8.162,6.041c-1.071,1.558-.276,1.85.277,3.1C1516.441,385.45,1516.075,387.034,1516.843,388.349Z",
    transform: "translate(-1507.079 -377.289)",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49861",
    "data-name": "Path 49861",
    d: "M1535.788,397.431c-.686-.125-1.631-.079-1.784.6a1.373,1.373,0,0,1-.086.385c-.189.339-.694.149-1.071.06a3.008,3.008,0,0,0-2.355.873,1.014,1.014,0,0,0-.461.582.839.839,0,0,0,.211.614,2.5,2.5,0,0,0,2.328.953c.533-.081,1.026-.335,1.553-.444a6.484,6.484,0,0,1,1.446-.067,5.171,5.171,0,0,0,3.484-.849c.7-.584,1.1-1.5,1.9-1.932.838-.451,2.1-.4,2.434-1.3a1.318,1.318,0,0,0-.555-1.447,3.207,3.207,0,0,0-1.575-.478,1.468,1.468,0,0,0-.6.027c-.447.144-.66.636-.957,1A4.947,4.947,0,0,1,1535.788,397.431Z",
    transform: "translate(-1512.155 -384.613)",
    opacity: 0.39,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49862",
    "data-name": "Path 49862",
    d: "M1590.94,401.61c-.674.32-1.383.877-1.346,1.622.047.922,1.2,1.462,1.328,2.376a8.523,8.523,0,0,1-.082,1.156,3.216,3.216,0,0,0,.478,1.43q.727,1.4,1.455,2.789a5.305,5.305,0,0,1,.688,1.855,1.8,1.8,0,0,1-.731,1.738,3.769,3.769,0,0,1-1.088.333,4.534,4.534,0,0,0-3.36,4.193,1.931,1.931,0,0,1-.08.7c-.169.414-.637.6-1.051.77-1.091.445-2.266,1.314-2.154,2.487a3.486,3.486,0,0,0,.429,1.174,30.738,30.738,0,0,1,2.125,6.8,5.062,5.062,0,0,1,3.361-.305,3.383,3.383,0,0,1,1.924,2.785,9.487,9.487,0,0,1-.422,3.507,2.006,2.006,0,0,0-.072,1.088,1.3,1.3,0,0,0,.654.722,2.464,2.464,0,0,0,2.826-.7,6.394,6.394,0,0,0,1.291-2.817,74.454,74.454,0,0,0,1.752-14.294c.291-5.07.579-10.187-.219-15.2a2.289,2.289,0,0,1,.144-1.663c.4-.587,1.218-.869.82-1.683-.235-.481-1.8-.906-2.275-1.078A8.335,8.335,0,0,0,1590.94,401.61Z",
    transform: "translate(-1530.781 -386.61)",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoEarthsec);
export default __webpack_public_path__ + "static/media/ufo-earthsec.6b9372fc8949143d5eb74f39e43e16dc.svg";
export { ForwardRef as ReactComponent };